import React, { useState, useEffect } from 'react';

const stats = [
  { num: '12,400+', label: 'Students enrolled' },
  { num: '3', label: 'Languages taught' },
  { num: '96%', label: 'Satisfaction rate' },
  { num: '38', label: 'Expert trainers' },
];

export default function Hero() {
  const [screen, setScreen] = useState('desktop');

  useEffect(() => {
    const handleResize = () => {
      const w = window.innerWidth;
      if (w < 640) setScreen('mobile');
      else if (w < 1024) setScreen('tablet');
      else setScreen('desktop');
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <section
      style={{
        background: 'var(--bg)',
        padding:
          screen === 'mobile'
            ? '4rem 1rem 3rem'
            : screen === 'tablet'
            ? '5rem 2rem 4rem'
            : '7rem 2rem 5rem',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Glow Orbs */}
      <div
        style={{
          position: 'absolute',
          top: '-60px',
          right: '10%',
          width: screen === 'mobile' ? '220px' : '480px',
          height: screen === 'mobile' ? '220px' : '480px',
          borderRadius: '50%',
          background:
            'radial-gradient(circle, rgba(15,244,198,0.12) 0%, transparent 70%)',
        }}
      />
      <div
        style={{
          position: 'absolute',
          bottom: '-40px',
          left: '-60px',
          width: screen === 'mobile' ? '180px' : '360px',
          height: screen === 'mobile' ? '180px' : '360px',
          borderRadius: '50%',
          background:
            'radial-gradient(circle, rgba(251,191,36,0.08) 0%, transparent 70%)',
        }}
      />

      {/* Grid texture */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          backgroundImage:
            'linear-gradient(rgba(99,179,237,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(99,179,237,0.03) 1px, transparent 1px)',
          backgroundSize: screen === 'mobile' ? '40px 40px' : '60px 60px',
        }}
      />

      <div style={{ maxWidth: '1120px', margin: '0 auto', position: 'relative', zIndex: 1 }}>

        {/* Badge */}
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '10px',
            background: 'rgba(15,244,198,0.08)',
            border: '1px solid rgba(15,244,198,0.25)',
            color: '#0ff4c6',
            fontSize: '12px',
            padding: '6px 14px',
            borderRadius: '999px',
            marginBottom: '1.5rem',
            flexWrap: 'wrap',
          }}
        >
          <span
            style={{
              width: '6px',
              height: '6px',
              borderRadius: '50%',
              background: '#0ff4c6',
            }}
          />
          #1 Language Speaking Platform in India
        </div>

        {/* Heading */}
        <h1
          style={{
            fontSize: 'clamp(32px, 7vw, 82px)', // ✅ responsive
            fontWeight: '800',
            lineHeight: 1.1,
            color: '#f0f4ff',
            marginBottom: '1rem',
          }}
        >
          Master <span style={{ color: '#0ff4c6' }}>English</span>
          <br />
          Speaking in just
          <br />
          <span style={{ color: '#fbbf24' }}>60 Days!</span>
        </h1>

        {/* Description */}
        <p
          style={{
            fontSize: screen === 'mobile' ? '14px' : '17px',
            color: '#94a3c4',
            maxWidth: '480px',
            marginBottom: '2rem',
          }}
        >
          From beginner to advanced — live interactive classes, real-life
          conversation training, and affordable pricing.
        </p>

        {/* Buttons */}
        <div
          style={{
            display: 'flex',
            flexDirection: screen === 'mobile' ? 'column' : 'row',
            gap: '12px',
            alignItems: 'center',
          }}
        >
          <button
            style={{
              width: screen === 'mobile' ? '100%' : 'auto',
              background: '#0ff4c6',
              padding: '12px 24px',
              borderRadius: '999px',
              border: 'none',
              fontWeight: '600',
              cursor: 'pointer',
            }}
          >
            Start free demo →
          </button>

          <button
            style={{
              width: screen === 'mobile' ? '100%' : 'auto',
              background: 'transparent',
              border: '1px solid rgba(99,179,237,0.3)',
              padding: '12px 24px',
              borderRadius: '999px',
              color: '#fff',
              cursor: 'pointer',
            }}
          >
            View courses
          </button>
        </div>

        {/* Stats */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns:
              screen === 'mobile'
                ? '1fr 1fr'
                : screen === 'tablet'
                ? 'repeat(2,1fr)'
                : 'repeat(4,1fr)',
            gap: '20px',
            marginTop: '3rem',
            paddingTop: '2rem',
            borderTop: '1px solid rgba(99,179,237,0.10)',
          }}
        >
          {stats.map((s) => (
            <div key={s.num}>
              <div
                style={{
                  fontSize: screen === 'mobile' ? '24px' : '34px',
                  fontWeight: '800',
                  color: '#0ff4c6',
                }}
              >
                {s.num}
              </div>
              <div style={{ fontSize: '12px', color: '#4a5878' }}>
                {s.label}
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}